export default "__VITE_ASSET__60e9ffcf__"